import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/getters.ts'), 'getters.ts')
  resolveStoreModules(require('../store/base/actions.ts'), 'base/actions.ts')
  resolveStoreModules(require('../store/base/getters.ts'), 'base/getters.ts')
  resolveStoreModules(require('../store/base/mutations.ts'), 'base/mutations.ts')
  resolveStoreModules(require('../store/base/state.ts'), 'base/state.ts')
  resolveStoreModules(require('../store/building/actions.ts'), 'building/actions.ts')
  resolveStoreModules(require('../store/building/getters.ts'), 'building/getters.ts')
  resolveStoreModules(require('../store/building/mutations.ts'), 'building/mutations.ts')
  resolveStoreModules(require('../store/building/state.ts'), 'building/state.ts')
  resolveStoreModules(require('../store/modal/actions.ts'), 'modal/actions.ts')
  resolveStoreModules(require('../store/modal/getters.ts'), 'modal/getters.ts')
  resolveStoreModules(require('../store/modal/mutations.ts'), 'modal/mutations.ts')
  resolveStoreModules(require('../store/modal/state.ts'), 'modal/state.ts')
  resolveStoreModules(require('../store/offer/actions.ts'), 'offer/actions.ts')
  resolveStoreModules(require('../store/offer/getters.ts'), 'offer/getters.ts')
  resolveStoreModules(require('../store/offer/mutations.ts'), 'offer/mutations.ts')
  resolveStoreModules(require('../store/offer/state.ts'), 'offer/state.ts')
  resolveStoreModules(require('../store/project/actions.ts'), 'project/actions.ts')
  resolveStoreModules(require('../store/project/getters.ts'), 'project/getters.ts')
  resolveStoreModules(require('../store/project/mutations.ts'), 'project/mutations.ts')
  resolveStoreModules(require('../store/project/state.ts'), 'project/state.ts')
  resolveStoreModules(require('../store/requestOffer/actions.ts'), 'requestOffer/actions.ts')
  resolveStoreModules(require('../store/requestOffer/getters.ts'), 'requestOffer/getters.ts')
  resolveStoreModules(require('../store/requestOffer/mutations.ts'), 'requestOffer/mutations.ts')
  resolveStoreModules(require('../store/requestOffer/state.ts'), 'requestOffer/state.ts')
  resolveStoreModules(require('../store/space/actions.ts'), 'space/actions.ts')
  resolveStoreModules(require('../store/space/getters.ts'), 'space/getters.ts')
  resolveStoreModules(require('../store/space/mutations.ts'), 'space/mutations.ts')
  resolveStoreModules(require('../store/space/state.ts'), 'space/state.ts')
  resolveStoreModules(require('../store/tutorial/actions.ts'), 'tutorial/actions.ts')
  resolveStoreModules(require('../store/tutorial/getters.ts'), 'tutorial/getters.ts')
  resolveStoreModules(require('../store/tutorial/mutations.ts'), 'tutorial/mutations.ts')
  resolveStoreModules(require('../store/tutorial/state.ts'), 'tutorial/state.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
